/**
 * This file is auto-generated
 */
export const upgradeGatewayMethods = [
    'convertSoloToTeams',
    'convertPersonalSignaturesToOrganization',
];
//# sourceMappingURL=upgrade-api.js.map